var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrustpilotRatings2HalfstarRgb = function SvgTrustpilotRatings2HalfstarRgb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98,
    height: 18,
    viewBox: "0 0 96 18"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Trustpilot_ratings_2halfstar-RGB_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.172.012H19V18H.172Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Trustpilot_ratings_2halfstar-RGB_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 .012h19V18H19Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Trustpilot_ratings_2halfstar-RGB_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39 .012h18V18H39Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Trustpilot_ratings_2halfstar-RGB_svg__d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39 .012h9V18h-9Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Trustpilot_ratings_2halfstar-RGB_svg__e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58 .012h19V18H58Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Trustpilot_ratings_2halfstar-RGB_svg__f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77 .012h18.746V18H77Zm0 0"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Trustpilot_ratings_2halfstar-RGB_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1e1e1e",
      fillOpacity: 1
    },
    d: "M18.09.012H.172v18H18.09Zm0 0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Trustpilot_ratings_2halfstar-RGB_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1e1e1e",
      fillOpacity: 1
    },
    d: "M37.504.012H19.586v18h17.918Zm0 0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Trustpilot_ratings_2halfstar-RGB_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#dcdce6",
      fillOpacity: 1
    },
    d: "M56.918.012H39v18h17.918Zm0 0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Trustpilot_ratings_2halfstar-RGB_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1e1e1e",
      fillOpacity: 1
    },
    d: "M47.957.012H39v18h8.957Zm0 0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Trustpilot_ratings_2halfstar-RGB_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#dcdce6",
      fillOpacity: 1
    },
    d: "M76.332.012H58.41v18h17.922Zm0 0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Trustpilot_ratings_2halfstar-RGB_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#dcdce6",
      fillOpacity: 1
    },
    d: "M95.746.012H77.824v18h17.922Zm0 0"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    },
    d: "m9.133 12.145 2.722-.696 1.141 3.528Zm6.27-4.56h-4.798L9.133 3.052 7.656 7.586H2.86l3.883 2.812-1.472 4.54 3.878-2.813 2.391-1.727ZM28.547 12.145l2.723-.696 1.14 3.528Zm6.27-4.56H30.02l-1.473-4.534-1.477 4.535h-4.797l3.883 2.812-1.476 4.54 3.883-2.813 2.39-1.727ZM47.957 12.145l2.727-.696 1.14 3.528Zm6.273-4.56h-4.796l-1.477-4.534-1.473 4.535h-4.797l3.883 2.812-1.476 4.54 3.883-2.813 2.39-1.727ZM67.371 12.145l2.727-.696 1.136 3.528Zm6.274-4.56h-4.797L67.37 3.052l-1.473 4.535h-4.796l3.878 2.812-1.472 4.54 3.883-2.813 2.39-1.727ZM86.785 12.145l2.727-.696 1.136 3.528Zm6.274-4.56h-4.801l-1.473-4.534-1.476 4.535h-4.797l3.883 2.812-1.473 4.54 3.883-2.813 2.386-1.727Zm0 0"
  }));
};
export default SvgTrustpilotRatings2HalfstarRgb;